import React, { useState, useEffect, useCallback } from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot } from '@mui/lab';
import DescriptionIcon from '@mui/icons-material/Description';
import GeneralEvolutionModal from "../generalEvolution/generalEvolutionModal"
import { useNavigate, useParams } from 'react-router-dom';
import Loading from '../../../components/loading';
import SuccessMessage from '../../../components/successMessage';
import ErrorMessage from '../../../components/errorMessage';
import api from "../../../api/api";


export default function GeneralEvolutionList({ patient }) {

    const navigate = useNavigate();

    const { patientId } = useParams();

    const [isLoading, setLoading] = useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [evolutions, setEvolutions] = useState([]);
    const [isModalOpen, setModalOpen] = useState(false);

    const getGeneralEvolutionsFromPatient = useCallback(() => {
        if (!patientId) {
            return;
        }
        setLoading(true);
        api.get(`/paciente/evolucao/${patientId}`, {
            headers: {
                Authorization: sessionStorage.getItem('token')
            }
        }).then((returnFromApi) => {
            setEvolutions(returnFromApi.data);
            setLoading(false);
        }).catch((returnFromApi) => {
            setLoading(false);
            console.error("ops! ocorreu um erro" + returnFromApi);
            setErrorMessage(returnFromApi.response.data);
            if (returnFromApi.status === 401) {
                navigate("/expired-session");
            }
        });
    }, [navigate, patientId]);

    useEffect(() => {
        getGeneralEvolutionsFromPatient();
    }, [patientId, getGeneralEvolutionsFromPatient]);

    const saveGeneralEvolution = (returnFromApi) => {
        if (returnFromApi.data) {
            setShowSuccessMessage(true);
            setSuccessMessage(returnFromApi.data);
        } else {
            setShowErrorMessage(true);
            setErrorMessage(returnFromApi.response.data);
        }
        setModalOpen(false);
        getGeneralEvolutionsFromPatient();
    };

    return (
        <>
            <Loading isToHidden={isLoading === false} />
            {showSuccessMessage && <SuccessMessage message={successMessage} show={showSuccessMessage} setShow={setShowSuccessMessage} />}
            {showErrorMessage && <ErrorMessage message={errorMessage} show={showErrorMessage} setShow={setShowErrorMessage} />}

            <Paper variant="outlined" sx={{ p: 3, borderRadius: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                    <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                        Evoluções Gerais
                    </Typography>
                    <Button variant="outlined" onClick={() => setModalOpen(true)}>
                        Adicionar Evolução
                    </Button>
                </Box>

                {evolutions.length === 0 ? (
                    <Typography align="center" sx={{ py: 4 }}>
                        Nenhuma evolução geral cadastrada ainda.
                    </Typography>
                ) : (
                    <Timeline sx={{ p: 0, [`& .MuiTimelineItem-root::before`]: { flex: 0, padding: 0 } }}>
                        {evolutions.map((evo, index) => (
                            <TimelineItem key={evo.id}>
                                <TimelineSeparator>
                                    <TimelineDot sx={{ backgroundColor: '#F5F5F5' }}>
                                        <DescriptionIcon fontSize="small" color="primary" />
                                    </TimelineDot>
                                    {index < evolutions.length - 1 && <TimelineConnector />}
                                </TimelineSeparator>

                                <TimelineContent sx={{ py: '12px', px: 2 }}>
                                    <Box sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        flexWrap: 'wrap'
                                    }}>
                                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                            {evo.data}
                                        </Typography>

                                        {evo.userName?.trim() && (
                                            <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                                                Adicionada por: {evo.userName}
                                            </Typography>
                                        )}
                                        
                                    </Box>
                                    <Typography
                                        variant="body2"
                                        color="textSecondary"
                                        sx={{ mt: 1, whiteSpace: 'pre-line' }}
                                    >
                                        {evo.evolucao}
                                    </Typography>
                                </TimelineContent>
                            </TimelineItem>
                        ))}
                    </Timeline>
                )}
            </Paper>

            <GeneralEvolutionModal
                open={isModalOpen}
                onClose={() => setModalOpen(false)}
                onEvolutionSave={saveGeneralEvolution}
            />
        </>
    );
}